module.exports = __webpack_public_path__ + "static/media/winOver.788655e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/winOver.mp3
// module id = FXjW
// module chunks = 1